/**
 * 后台展示用时间：yyyy-MM-dd HH:mm:ss（去掉 ISO 小数秒与 Z）。
 * @param {unknown} v
 * @returns {string}
 */
export function formatDateTimeForDisplay(v) {
  if (v == null || v === '') return '—'
  let s = String(v).trim().replace('T', ' ')
  s = s.replace(/\.\d+/, '')
  s = s.replace(/Z$/i, '')
  s = s.replace(/\s+$/, '')
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(s)) s = `${s}:00`
  if (s.length > 19) s = s.slice(0, 19)
  return s || '—'
}

/**
 * 活动起止时间展示：优先 structured 字段，否则解析 dateRange 文本。
 * @param {Record<string, unknown>} raw
 * @returns {string}
 */
export function formatActivityTimeRange(raw) {
  if (!raw || typeof raw !== 'object') return '—'
  const start = raw.activityStartAt ?? raw.activity_start_at
  const end = raw.activityEndAt ?? raw.activity_end_at
  const startText = formatDateTimeForDisplay(start)
  const endText = formatDateTimeForDisplay(end)
  const hasStart = start != null && String(start).trim() !== ''
  const hasEnd = end != null && String(end).trim() !== ''
  if (hasStart && hasEnd) return `${startText} ~ ${endText}`
  if (hasStart) return startText
  if (hasEnd) return endText

  const range = String(raw.dateRange ?? raw.date_range ?? '').trim()
  if (!range) return '—'
  if (range.includes('~')) {
    return range
      .split('~')
      .map((part) => formatDateTimeForDisplay(part.trim()))
      .join(' ~ ')
  }
  return formatDateTimeForDisplay(range)
}
